export const TERRITORY_CREATE_RESET = 'TERRITORY_CREATE_RESET'
export const TERRITORY_CREATE_SET_CREATED = 'TERRITORY_CREATE_SET_CREATED'
export const TERRITORY_CREATE_SET_ERROR = 'TERRITORY_CREATE_SET_ERROR'
export const TERRITORY_CREATE_SET_VIOLATIONS = 'TERRITORY_CREATE_SET_VIOLATIONS'
export const TERRITORY_CREATE_TOGGLE_LOADING = 'TERRITORY_CREATE_TOGGLE_LOADING'
